let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ejFfH")).then(() => parcelRequire('7299x'));